import axiosInstance from "../services/AxiosInstance"

const API_URL = "/urls"
const URLS_PAGE_CAP = 100
const URLS_DEFAULT_LIMIT = 10

// Get all batches with optional pagination and search
export const geturls = async (limit = 10, page = 1, search = "", includeTotal = true) => {
  try {
    const safeLimit = Math.max(1, Math.min(URLS_PAGE_CAP, Number.parseInt(limit, 10) || URLS_DEFAULT_LIMIT))
    const safePage = Math.max(1, Number.parseInt(page, 10) || 1)
    const safeSearch = search || ""
    const response = await axiosInstance.get(`${API_URL}?limit=${safeLimit}&page=${safePage}&search=${safeSearch}&includeTotal=${includeTotal ? "true" : "false"}`)
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching batches", error)
    throw error
  }
}

// Create a new batch
export const createurls = async (batchData) => {
  try {
    const response = await axiosInstance.post(API_URL, batchData)
    return response.data
  } catch (error) {
    console.error("Error creating batch", {
      error: error.response?.data,
      requestData: batchData,
    })
    throw error
  }
}

// Update a batch by ID
export const updateurls = async (batchId, batchData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${batchId}`, batchData)
    return response.data
  } catch (error) {
    console.error("Error updating batch", error)
    throw error
  }
}

// Delete a batch by ID
export const deleteurls = async (batchId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${batchId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting batch", error)
    throw error
  }
}

// Get a batch by ID

export const geturlsById = async (batchId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${batchId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching batch details", error)
    throw error
  }
}
